import {Service, signal} from '@angular/core'
import {toObservable} from '@angular/core/rxjs-interop'

@Service()
export class ConfigService {
  /**
   * True if we are running inside an iframe/frame on /internetbank route.
   */
  public onInternetBankRoute = signal<boolean>(false)

  /**
   * True if we are running on mobile bank context (&context=mobilbanken).
   */
  public onMobileBankContext = false

  /**
   * The user access token if logged in from internetbanken (NeOS)
   */
  public userAccessToken = signal<string | null>(null)
  public userAccessToken$ = toObservable(this.userAccessToken)
}
